import { Font } from '@react-pdf/renderer'
import notoGreek400 from '../assets/fonts/noto-sans-greek-400-normal.woff'
import notoGreek700 from '../assets/fonts/noto-sans-greek-700-normal.woff'

export function registerNotoSansPdfFonts() {
  if (Font.getRegisteredFontFamilies().includes('NotoSans')) return
  Font.register({
    family: 'NotoSans',
    fonts: [
      { src: notoGreek400, fontWeight: 400 },
      { src: notoGreek700, fontWeight: 700 },
    ],
  })
}
